import React from 'react';
import './Layout.css';

export default class Layout extends React.Component{
    render(){
        return(
            <div>Mi contenidos</div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/Layout.js